import { MouseEvent, useCallback, useState } from "react"

type UseAnchorMenuReturn = Readonly<{
    anchorEl: HTMLElement | null
    isOpen: boolean
    open: (event: MouseEvent<HTMLElement>) => void
    close: () => void
    /** Closes the menu, then runs the picked item's action. */
    closeThen: (action: () => void) => () => void
}>

/** Anchor state for a click-opened MUI Menu. Hover menus use useHoverMenu instead. */
export function useAnchorMenu(): UseAnchorMenuReturn {
    const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null)

    const open = useCallback((event: MouseEvent<HTMLElement>) => setAnchorEl(event.currentTarget), [])
    const close = useCallback(() => setAnchorEl(null), [])
    const closeThen = useCallback(
        (action: () => void) => () => {
            setAnchorEl(null)
            action()
        },
        [],
    )

    return { anchorEl, isOpen: anchorEl !== null, open, close, closeThen }
}
